<template>
	<div
		class="relative z-5 flex h-60 w-full min-w-0 flex-col items-center justify-center px-5 transition-opacity"
		:class="{ 'opacity-60': eliminated }"
	>
		<Transition
			enterActiveClass="transition-all"
			leaveActiveClass="transition-all"
			enterFromClass="scale-0 opacity-0"
			leaveToClass="scale-0 opacity-0"
		>
			<div
				class="text-lime absolute inset-0 flex items-center justify-center"
				v-if="won"
			>
				<WonBgIcon ref="wonRef" />
			</div>
		</Transition>
		<template v-if="avatar && name">
			<div
				class="relative rounded-full p-0.5 transition-all duration-500"
				:class="{
					'from-lime/20 to-lime/0 bg-[#121212] bg-linear-to-t': won,
					'bg-[#121212]': !won,
					'opacity-60': eliminated,
					'translate-y-1/2 opacity-0': !localShow
				}"
			>
				<LazyImage
					:src="avatarSm(avatar)"
					:alt="name"
					class="h-10 w-10 rounded-full border-2 border-black"
				/>
				<svg
					v-if="eliminated"
					class="text-label-primary absolute -top-2.5 -left-2.5 h-16 w-16"
					width="64"
					height="64"
					viewBox="0 0 64 64"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g
						:filter="`url(#${id}_filter0_d_457_3119)`"
						style="transform-origin: center center"
					>
						<path
							:mask="`url(#${id}_leftMask)`"
							d="M10.6152 11.2439C10.486 10.5604 10.964 10.2666 11.5576 10.491C12.4254 10.8191 12.7363 11.49 13.5264 11.3162C15.1058 10.9682 15.7376 10.86 15.9541 12.198C16.1707 13.5361 17.8117 12.6284 18.1182 13.2283C18.4242 13.8282 17.6658 14.573 20.5488 16.2976C23.4318 18.0222 24.8429 19.1373 25.8545 19.8708C26.8662 20.6044 28.0357 23.0798 29.6934 24.2664C31.3509 25.4529 34.0261 28.5595 35.5771 29.3396C37.1279 30.1194 36.2895 30.9631 36.7607 32.3748C37.2325 33.7866 40.052 32.4507 40.9062 33.8923C41.7602 35.3338 40.8303 36.608 42.3926 37.6746C43.9549 38.7411 44.5167 40.8102 45.5547 40.9431C46.593 41.0754 45.2855 42.5069 46.4209 43.0339C47.5562 43.561 47.8813 44.2437 48.1631 45.4158C48.4451 46.5881 50.2983 49.2013 51.6572 49.4666C53.0162 49.7318 52.9932 51.6073 53.3252 52.3894C53.4285 52.6329 53.4697 52.8656 53.4746 53.0701C53.4763 53.1566 53.4085 53.2661 53.3213 53.3533C53.2127 53.4618 53.0738 53.5366 53.0029 53.4939C52.6595 53.284 52.0696 53.0468 51.1865 52.9529C49.54 52.7779 50.2531 51.8652 48.6455 51.0134C47.0375 50.1616 45.5423 50.1778 44.584 48.2419C43.6256 46.3064 41.2478 48.0189 40.3643 44.8171C39.4807 41.6157 37.1266 43.5395 34.8066 41.7888C32.4865 40.0376 31.0965 36.2873 29.7715 35.158C28.4466 34.0288 26.5499 32.6297 25.0928 30.6082C23.6355 28.5863 20.775 27.1512 19.3584 24.7273C17.942 22.3035 15.8632 18.9529 15.0352 17.2722C14.2073 15.5918 13.9979 15.1896 12.5303 14.2429C11.6868 13.6988 10.8721 12.6017 10.6152 11.2439Z"
							fill="currentColor"
						/>
						<path
							:mask="`url(#${id}_rightMask)`"
							d="M55.1191 7.92188C55.7454 7.62794 56.196 7.87159 55.9883 8.57812C55.5755 9.98193 54.6272 11.1843 53.7119 11.8301C52.1199 12.9534 51.862 13.3844 50.835 15.1787C49.8076 16.9734 47.3267 20.5997 45.6201 23.2129C43.9134 25.8263 40.8562 27.6006 39.1533 29.8115C37.4505 32.0225 35.3728 33.653 33.9043 34.9453C32.4359 36.2376 30.6072 40.1896 28.0615 42.2236C25.5156 44.2574 23.3484 42.5749 22.0938 45.916C20.8391 49.257 18.6235 47.7897 17.4355 49.8574C16.2476 51.9252 14.7365 52.0769 13.0127 53.1201C11.289 54.1633 11.9083 55.0068 10.2217 55.3691C9.31734 55.5634 8.69357 55.87 8.32227 56.1211C8.24579 56.1727 8.11352 56.1124 8.01562 56.0146C7.93712 55.936 7.87992 55.833 7.8916 55.7451C7.91954 55.5375 7.98707 55.2973 8.11914 55.0391C8.54317 54.2099 8.73133 52.3142 10.1367 51.8926C11.5424 51.4713 13.7126 48.617 14.1299 47.3984C14.5469 46.1801 14.9535 45.4522 16.1621 44.791C17.3703 44.1298 16.208 42.8281 17.2734 42.5771C18.3395 42.3263 19.1409 40.1678 20.8428 38.9121C22.5448 37.6565 21.7465 36.4707 22.7734 34.915C23.8006 33.3598 26.5043 34.3956 27.1406 32.9131C27.7768 31.4306 27.0229 30.671 28.6807 29.707C30.3387 28.743 33.3963 25.296 35.208 23.9082C37.0196 22.5205 38.4821 19.884 39.5889 19.0273C40.6956 18.1709 42.25 16.8831 45.3633 14.8125C48.4766 12.7419 47.7913 12.0725 48.1689 11.4307C48.5469 10.7894 50.1058 11.5242 50.4756 10.1455C50.8452 8.76621 51.4732 8.80387 53.0332 8.97852C53.8135 9.06557 54.2037 8.35167 55.1191 7.92188Z"
							fill="currentColor"
						/>
						<animate
							attributeName="opacity"
							values="0; 1"
							dur="0.4s"
							begin="0s"
							fill="freeze"
							repeatCount="1"
							restart="always"
						/>
						<animateTransform
							attributeName="transform"
							type="scale"
							values="1.3; 1"
							dur="0.4s"
							begin="0s"
							fill="freeze"
							repeatCount="1"
							restart="always"
						/>
					</g>
					<defs>
						<filter
							:id="`${id}_filter0_d_457_3119`"
							x="7.88867"
							y="7.79984"
							width="48.1494"
							height="49.3401"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="1" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_457_3119"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_457_3119"
								result="shape"
							/>
						</filter>
						<mask :id="`${id}_leftMask`" mask-type="luminance">
							<rect x="0" y="0" width="0" height="0" fill="white">
								<animate
									attributeName="width"
									values="0; 64"
									dur="0.3s"
									begin="0s"
									fill="freeze"
									repeatCount="1"
									restart="always"
								/>
								<animate
									attributeName="height"
									values="0; 64"
									dur="0.3s"
									begin="0s"
									fill="freeze"
									repeatCount="1"
									restart="always"
								/>
							</rect>
						</mask>
						<mask :id="`${id}_rightMask`" mask-type="luminance">
							<rect x="64" y="0" width="64" height="0" fill="white">
								<animate
									attributeName="x"
									values="64; 0"
									dur="0.3s"
									begin="0.3s"
									fill="freeze"
									repeatCount="1"
									restart="always"
								/>
								<animate
									attributeName="height"
									values="0; 64"
									dur="0.3s"
									begin="0.3s"
									fill="freeze"
									repeatCount="1"
									restart="always"
								/>
							</rect>
						</mask>
					</defs>
				</svg>
			</div>
			<div
				class="text-label-primary mt-4 max-w-full min-w-0 truncate text-sm font-semibold uppercase transition-all duration-600"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
			>
				{{ name }}
			</div>
			<div
				class="text-label-secondary mt-1 text-xs font-medium uppercase transition-all duration-700"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
				v-if="amount === -1"
			>
				{{ t('ready') }}
			</div>
			<CoinPrice
				class="mt-1 transition-all duration-700"
				:class="[
					textColor,
					{
						'*:text-lime!': won,
						'animate-blink': blinkCoins,
						'translate-y-1/2 opacity-0': !localShow
					}
				]"
				:price="amount"
				:minDigits="2"
				:noCoin="!!jackpot"
				:suffix="jackpot ? '%' : undefined"
				mono
				v-else
			/>
		</template>
		<template v-else>
			<LoaderIcon
				class="text-label-tertiary h-5 w-5 transition-all duration-500"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
			/>
			<div
				class="text-label-primary mt-4 text-sm font-semibold uppercase transition-all duration-600"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
			>
				{{ t('waiting') }}
			</div>
			<div
				class="text-label-secondary mt-1 text-center text-xs font-medium uppercase transition-all duration-700"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
			>
				{{ t('players') }}
			</div>
		</template>
		<Transition
			leaveActiveClass="!transition-all !duration-500"
			leaveToClass="opacity-0 scale-0 !mt-0 !h-0 !min-h-0"
		>
			<BaseButton
				size="md"
				color="primary"
				class="mt-5 transition-all duration-800"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
				@click="sendAction"
				:loading="loading"
				v-if="showAction"
			>
				{{ actionText }}
			</BaseButton>
		</Transition>
		<Transition
			leaveActiveClass="!transition-all !duration-500"
			leaveToClass="opacity-0 scale-0 !mt-0 !h-0 !min-h-0"
		>
			<BaseButton
				size="md"
				color="secondary"
				class="mt-1.5 uppercase transition-all duration-800"
				:class="{ 'translate-y-1/2 opacity-0': !localShow }"
				@click="sendSecondaryAction"
				:loading="secondaryLoading"
				v-if="showSecondaryAction"
			>
				{{ secondaryActionText }}
			</BaseButton>
		</Transition>
	</div>
</template>
<script setup lang="ts">
import LazyImage from './LazyImage.vue'
import LoaderIcon from '@/assets/icons/loader.svg'
import BaseButton from './BaseButton.vue'
import { computed, onMounted, ref, nextTick } from 'vue'
import CoinPrice from './CoinPrice.vue'
import { sleep } from '@/utils/sleep'
import WonBgIcon from '@/assets/icons/won-bg.svg'
import { avatarSm } from '@/utils/urls'
import { useI18n } from 'vue-i18n'
import { chance } from '@/utils/chance'

const colors = [
	'*:text-[#E01533]!', // red
	'*:text-[#E4A211]!', // yellow
	'*:text-[#E06315]!', // orange
	'*:text-[#84B611]!' // green
]

const { t } = useI18n({
	messages: {
		en: {
			ready: 'ready',
			waiting: 'waiting',
			players: 'for players...',
			call: 'call bot',
			join: 'join'
		},
		ru: {
			ready: 'готов',
			waiting: 'ожидание',
			players: 'игроков...',
			call: 'позвать бота',
			join: 'войти'
		}
	}
})

const props = defineProps<{
	id: string
	index: number
	team: number
	avatar?: string
	name?: string
	eliminated?: boolean
	won?: boolean
	jackpot?: number
	isCrazy?: boolean
	participantTickets: { teamIndex: number; tickets: number }[]
	action: 'join' | 'call_bot' | 'none' | 'join_and_call_bot'
}>()

const emit = defineEmits<{
	(e: 'callBot'): void
	(e: 'join'): void
}>()

const amount = ref(-1)

let start = 0
const createAnimationFrame = (from: number, to: number, duration: number) => {
	start = performance.now()
	const animate = (current: number) => {
		const progress = (current - start) / duration
		amount.value = from + (to - from) * progress
		if (progress < 1) {
			requestAnimationFrame(animate)
		} else {
			amount.value = to
		}
	}
	requestAnimationFrame(animate)
}

const blinkCoins = ref(false)

const toChance = (value: number) => {
	if (!props.jackpot) {
		return value
	}

	return chance(props.index, props.participantTickets, props.isCrazy) * 10000
}

const setAmount = async (
	value: number,
	animate?: boolean,
	duration?: number,
	blink?: boolean
) => {
	blinkCoins.value = false

	if (!animate) {
		amount.value = value ? toChance(value) : value
		return
	}

	if (amount.value === -1) {
		amount.value = 0
	}

	const from = amount.value
	const to = value ? toChance(value) : value
	createAnimationFrame(from, to, duration ? duration : 1000)

	await sleep(duration ? duration : 1000)

	if (blink) {
		blinkCoins.value = true
	}
}

const showAction = computed(() => {
	return (!props.avatar || !props.name) && props.action !== 'none'
})

const showSecondaryAction = computed(() => {
	return showAction.value && props.action === 'join_and_call_bot'
})

const actionText = computed(() => {
	if (props.action === 'call_bot') {
		return t('call')
	}

	return t('join')
})

const secondaryActionText = computed(() => {
	if (props.action === 'join_and_call_bot') {
		return t('call')
	}

	return ''
})

const textColor = computed(() => {
	if (!props.jackpot) {
		return undefined
	}

	return colors[props.team] ? colors[props.team] : undefined
})

const loading = ref(false)
const sendAction = async () => {
	if (loading.value) {
		return
	}

	loading.value = true

	if (props.action === 'join_and_call_bot') {
		emit('join')
	} else if (props.action === 'call_bot') {
		emit('callBot')
	} else if (props.action === 'join') {
		emit('join')
	}

	await sleep(1000)

	loading.value = false
}

const secondaryLoading = ref(false)
const sendSecondaryAction = async () => {
	if (secondaryLoading.value) {
		return
	}

	secondaryLoading.value = true

	if (props.action === 'join_and_call_bot') {
		emit('callBot')
	}

	await sleep(1000)

	secondaryLoading.value = false
}

const localShow = ref(false)

onMounted(async () => {
	await sleep(10)
	localShow.value = true
})

defineExpose({
	setAmount
})
</script>
